import { useMemo, useSyncExternalStore } from 'react'
import {
  clearDemoUserEmail,
  getDemoUserEmail,
  isDemoUserEnvironment,
  setDemoUserEmail,
  subscribeToDemoUserChanges,
} from '../utils/demoUser'

export function useDemoUser() {
  const demoModeAvailable = isDemoUserEnvironment()
  const demoUserEmail = useSyncExternalStore(
    subscribeToDemoUserChanges,
    getDemoUserEmail,
    () => null
  )

  return useMemo(() => ({
    demoModeAvailable,
    demoUserEmail,
    isUsingDemoUser: Boolean(demoUserEmail),
    setDemoUserEmail,
    clearDemoUserEmail,
  }), [demoModeAvailable, demoUserEmail])
}
